// extracted by mini-css-extract-plugin
export var dropdownButton = "_2q-0";
export var fullWidthDropdownButton = "_2q-1";
export var icon = "_2q-3";
export var iconPlaceholder = "_2q-2";
export var shortcutContainer = "_2q-4";